module.exports = __webpack_public_path__ + "static/media/Discover.92c71f67.jpg";